export const customEvents = {
  apiErrorEvent: 'api-error',
  logOffEvent: 'logoff',
  newTokenEvent: 'new-token',
  refreshToken: 'refresh-token',
} as const;
